import { AxiosResponse } from 'axios';
import { AuthControllerApi, TokenResponseDto } from 'client';
import { AuthServices } from './AuthServices';

export class AuthServicesImpl implements AuthServices {
	private authController: AuthControllerApi;
	constructor() {
		this.authController = new AuthControllerApi();
	}
	async login(): Promise<AxiosResponse<TokenResponseDto>> {
		return this.authController.loginUsingGET(`Bearer ${process.env.REACT_APP_API_LOGIN_TOKEN}`);
	}
}
